import { useTranslation } from 'react-i18next'

import { USER_STATUS_TEXT } from '../../../../constants/user'
import { getSelectDropdownEntityListItenInfoStylesMods } from '../../../Select'
import { Status } from '../../../Status'
import Text from '../../../Text'

import * as styles from './UserSelectDropdownListItemContentInfoAdditionalData.module.css'

function UserSelectDropdownListItemContentInfoAdditionalData({
  className = styles.UserSelectDropdownListItemContentInfoAdditionalData,
  ref,
  value,
  ...restProps
}) {
  const { t } = useTranslation()

  const { additionalData, status } = value

  const emailClassName = getSelectDropdownEntityListItenInfoStylesMods({
    ...restProps,
    className: styles.email,
    styles,
  })

  return additionalData || Number.isFinite(status) ? (
    <div className={className} ref={ref}>
      {Number.isFinite(status) ? (
        <Status
          className={styles.chip}
          text={t(USER_STATUS_TEXT[status].text)}
          textColor={USER_STATUS_TEXT[status].color}
        />
      ) : (
        <Text isSecondary className={emailClassName} ref={ref}>
          {additionalData}
        </Text>
      )}
    </div>
  ) : null
}

export default UserSelectDropdownListItemContentInfoAdditionalData
